module.exports = __webpack_public_path__ + "static/media/sologoazul.57a80c09.png";